import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { DataService } from '../data';
import { APIService } from '../../api';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
  kh: number;
  sum: number;
  checked: boolean;

  constructor(
    private http: HttpClient,
    private dataService: DataService,
    private apiService: APIService,
  ) {
    this.checked = false;
  }

  ngOnInit() {
    this.sum =
      this.dataService.userInfo && this.dataService.userInfo.balance < 0
        ? this.dataService.userInfo.balance * -1
        : undefined;
    this.kh = this.dataService.kh;
  }

  onClickPayButton(isQRC: boolean) {
    if (!this.kh || !this.sum || !this.checked) {
      return;
    }

    this.http
      .post(`/api/bank/order?kh=${this.kh}&sum=${this.sum}&isQRC=${isQRC}`, { responseType: 'blob' })
      .subscribe((response: any) => {
        const { adviceIfaceAddress } = response;

        window.open(adviceIfaceAddress, '_self');
      });
  }
}
